import { PropTypes } from "@l2r-front/l2r-proptypes"

import { FILTERS } from "../../constants/filters"
import { DocumentFiltersFormPost } from "../../forms/DocumentFiltersForm/DocumentFiltersForm.post"

import * as Styled from "./DocumentFiltersForm.styled"

export function DocumentFiltersForm(props) {

    const {
        className,
        close,
        displayFilters,
    } = props

    return <div className={className} >
        <Styled.Collapse in={displayFilters}>
            <DocumentFiltersFormPost close={close} enabledFilters={FILTERS} />
        </Styled.Collapse>
    </div>
}

DocumentFiltersForm.propTypes = {
    className: PropTypes.string,
    close: PropTypes.func.isRequired,
    displayFilters: PropTypes.bool,
}